import React from "react";
import { MY_SIGNUP_TABS } from "../utils/filterAndSortUtils";

const DashboardTabs = ({
  activeTab,
  onTabChange,
  counts = {},
  showDue = false,
}) => {
  const tabs = MY_SIGNUP_TABS.filter((tab) => tab.id !== "due" || showDue);

  return (
    <nav
      className="flex flex-wrap px-2 sm:px-4"
      aria-label="Signup tabs"
    >
      {tabs.map((tab) => {
        const selected = activeTab === tab.id;
        const count = counts[tab.id] ?? 0;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center gap-2 min-h-11 py-2 px-3 sm:px-4 border-b-2 font-display font-bold text-sm tracking-wide whitespace-nowrap transition-colors duration-200 ${
              selected
                ? "border-brand-charcoal text-brand-charcoal"
                : "border-transparent text-brand-muted hover:text-brand-charcoal"
            }`}
          >
            <span>{tab.label}</span>
            <span
              className={`py-0.5 px-2 rounded-full text-xs font-medium tabular-nums ${
                selected
                  ? "bg-brand-gold text-brand-charcoal"
                  : "bg-brand-charcoal/10 text-brand-muted"
              }`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default DashboardTabs;
